export const termArray = [
  { id: 1, label: "Term 1" },
  { id: 2, label: "Term 2" },
  { id: 3, label: "Final Term" },
];
export const getTermName = (id) => {
  return termArray.find((term) => `${term.id}` === `${id}`).label;
};
